import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 'new-booking',
      title: 'New Booking',
      description: 'Schedule a new service appointment',
      icon: 'Calendar',
      color: 'primary',
      onClick: () => console.log('New booking clicked')
    },
    {
      id: 'customer-management',
      title: 'Customer Management',
      description: 'View and manage customer database',
      icon: 'Users',
      color: 'success',
      onClick: () => navigate('/customer-portal')
    },
    {
      id: 'inventory',
      title: 'Inventory',
      description: 'Track supplies and equipment',
      icon: 'Package',
      color: 'warning',
      onClick: () => console.log('Inventory clicked')
    },
    {
      id: 'reports',
      title: 'Reports',
      description: 'Generate business analytics',
      icon: 'BarChart3',
      color: 'secondary',
      onClick: () => console.log('Reports clicked')
    },
    {
      id: 'staff-schedule',
      title: 'Staff Schedule',
      description: 'Manage team assignments',
      icon: 'Clock',
      color: 'primary',
      onClick: () => console.log('Staff schedule clicked')
    },
    {
      id: 'emergency',
      title: 'Emergency Booking',
      description: 'Handle urgent service requests',
      icon: 'AlertTriangle',
      color: 'error',
      onClick: () => console.log('Emergency booking clicked')
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'success':
        return 'bg-success/10 text-success border-success/20 hover:bg-success/20';
      case 'warning':
        return 'bg-warning/10 text-warning border-warning/20 hover:bg-warning/20';
      case 'error':
        return 'bg-error/10 text-error border-error/20 hover:bg-error/20';
      case 'secondary':
        return 'bg-secondary/10 text-secondary border-secondary/20 hover:bg-secondary/20';
      default:
        return 'bg-primary/10 text-primary border-primary/20 hover:bg-primary/20';
    }
  };

  return (
    <div className="bg-white rounded-lg border border-border">
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-text-primary">Quick Actions</h3>
        <p className="text-sm text-text-secondary">Access frequently used functions</p>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {actions?.map((action) => (
            <button
              key={action?.id}
              onClick={action?.onClick}
              className={`p-4 rounded-lg border text-left transition-all duration-200 hover:shadow-elevation-1 ${getColorClasses(action?.color)}`}
            >
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <Icon name={action?.icon} size={24} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-medium text-text-primary mb-1">{action?.title}</h4>
                  <p className="text-sm opacity-80">{action?.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;